import cx from 'classnames';
import { Fragment } from 'react';
import useCountdown from '../lib/useCountdown';

/**
 * @typedef Props
 * @prop {boolean=} hideZeroes
 * @prop {boolean=} pause
 * @prop {boolean=} showRedText
 * @prop {'small' | 'large'} size
 * @prop {string | Date} to
 */

/**
 * @param {Props} props
 */
export default function SaleCountdown({
  hideZeroes = false,
  pause = false,
  size,
  to,
  showRedText = false,
}) {
  const countdown = useCountdown(to, pause);

  return (
    <>
      <div
        className={cx('tw-inline-flex', {
          'tw-ml-[-11px] xl:tw-ml-[-12px]': size === 'large',
          'tw-ml-[-2px]': size === 'small',
        })}>
        {Object.keys(countdown).map((key, index, items) => {
          if (hideZeroes && countdown[key] === '00' && index < 2) {
            return null;
          }
          return (
            <Fragment key={key}>
              <div
                className={cx('tw-text-center', {
                  'tw-font-medium tw-w-[60px]': size === 'large',
                  'tw-w-[22px]': size === 'small',
                })}>
                <div
                  className={cx({
                    'tw-text-red-500': showRedText,
                    'tw-text-3xl': size === 'large',
                  })}>
                  {countdown[key]}
                </div>
                {size === 'large' && (
                  <div className="tw-text-xs tw-font-light tw-pt-1">{key}</div>
                )}
              </div>
              {index !== items.length - 1 && (
                <div
                  className={cx({
                    'tw-text-3xl tw-text-gray-400': size === 'large',
                    'tw-text-red-500': size === 'small' && showRedText,
                  })}>
                  :
                </div>
              )}
            </Fragment>
          );
        })}
      </div>
    </>
  );
}
